import { render } from "./RadarChart.vue?vue&type=template&id=05d6f105&scoped=true"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"

import "./RadarChart.vue?vue&type=style&index=0&id=05d6f105&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d6f105"]])

export default __exports__